import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import Versions from '../../components/versions';

@withText(props => ({
    title: <Text id='input.title-help'>title</Text>,
}))
@observer
class NewCourse extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('course'),
        };
    }

    createCourse = async () => {
        const { callback = () => {} } = this.props;
        const { courseStore } = this.props.stores;
        const { newCourse } = courseStore;
        const response = await courseStore.adminCreate(newCourse);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { courseStore } = this.props.stores;
        courseStore.loadExamOptions();
        if (!isNew) {
            courseStore.adminSetFromId(id);
        }
    }

    render() {
        const { isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, courseStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newCourse, course } = courseStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {course && course.id && <Versions stores={this.props.stores} type='course' id={course.id} key={`admin-course-${course.id}`} />}

                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='course.new'>New course</Text> : <Text id='course.edit'>Edit course</Text>}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={courseStore} objectName={isNew ? 'newCourse' : 'course'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createCourse}>
                            {isNew ? <Text id='course.create'>Create course</Text> : <Text id='course.save'>Save course</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewCourse;
